import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
class Aviso extends React.PureComponent {
    render() {
        if (typeof this.props.show !== "undefined" && !this.props.show) {
            return null;
        }
        if (typeof this.props.isLoading !== "undefined" && this.props.isLoading) {
            return (_jsxs("div", { className: this.props.className ? this.props.className : "", style: { textAlign: "center" }, children: [_jsx("i", { className: "center-block fal fa-circle-notch fa-spin fa-3x fa-fw" }), _jsx("span", { className: "sr-only", children: "Loading..." })] }));
        }
        if (typeof this.props.error !== "undefined" && this.props.error) {
            return (_jsx("div", { className: "mb-1 col", children: _jsxs("div", { className: "alert alert-danger", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-exclamation-triangle" }), " ", this.props.errorMessage
                            ? this.props.errorMessage
                            : "An error occured"] }) }));
        }
        if (!this.props.children) {
            return null;
        }
        return this.props.children;
    }
}
export default Aviso;
